import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
/** Common Components */
import FormCreator from "../../../components/finalForms/FormCreator";
import Buttons from "../../../components/ui/button/Buttons";
import { AppIcons } from "../../../data/appIcons";
/** Common Services & Data Files */
import { planningStatusFormData } from "./config/planningStatus.data";
import { useAddPlanningStatusMutation, useUpdatePlanningStatusMutation } from "../../../app/services/planningStatusAPI";
import ToastService from "../../../services/toastService/ToastService";

export const AddEditPlanningStatus = (props) => {
    /* State*/
    const [projectStatusForm, setProjectStatusForm] = useState(planningStatusFormData);
    const PlanningStatuseRef = useRef();
    // API'S Call
    const [addPlanningstatus, {
        isSuccess: isPlanningStatusAdded,
        isLoading: isPlanningStatusAdding,
        data: addPlanningStatusData
    }] = useAddPlanningStatusMutation()
    const [updatePlanningStatus, {
        isLoading: isPlanningStatusUpdating,
        isSuccess: isPlanningStatusSuccess,
        data: isPlanningStatusUpdateData
    },] = useUpdatePlanningStatusMutation();

    //** useEffect's */

    useEffect(() => {
        if (props.isEdit && props.planningStatusData) {
            const formData = { ...planningStatusFormData }
            formData.initialState = {
                statusName: props.planningStatusData.statusName,
                isActive: props.planningStatusData.isActive,
                isComplete: props.planningStatusData.isComplete,
                isDefault: props.planningStatusData.isDefault
            }
            setProjectStatusForm(formData);
        } else {
            formReset();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.isEdit && props.planningStatusData]);

    useEffect(() => {
        if (isPlanningStatusAdded && addPlanningStatusData) {
            if (addPlanningStatusData.errorMessage?.includes("exists")) {
                ToastService.warning(addPlanningStatusData.errorMessage);
            } else {
                ToastService.success(addPlanningStatusData.errorMessage);
                props.onSuccess?.();
                backToList();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPlanningStatusAdded, addPlanningStatusData]);

    useEffect(() => {
        if (isPlanningStatusSuccess && isPlanningStatusUpdateData) {
            if (isPlanningStatusUpdateData.errorMessage?.includes("exists")) {
                ToastService.warning(isPlanningStatusUpdateData.errorMessage);
            } else {
                ToastService.success(isPlanningStatusUpdateData.errorMessage);
                props.onSuccess?.();
                backToList();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPlanningStatusSuccess, isPlanningStatusUpdateData]);

    //** Funcation's */

    const formReset = () => {
        const projectForm = { ...planningStatusFormData };
        projectForm.initialState = { ...planningStatusFormData.initialState };
        setProjectStatusForm(projectForm);
    };

    const handleSubmit = () => {
        let PlanningStatusData = PlanningStatuseRef.current.getFormData();
        if (PlanningStatusData) {
            const requestData = {
                ...PlanningStatusData,
                planningStatusId: props.isEdit ? props.planningStatusData.planningStatusId : 0,
                statusName: PlanningStatusData.statusName.trim(), // Trim status name
                isActive: PlanningStatusData.isActive || false,
                isComplete: PlanningStatusData.isComplete || false,
                isDefault: PlanningStatusData.isDefault || false
            };
            if (props.isEdit) {
                updatePlanningStatus(requestData)
            } else {
                addPlanningstatus(requestData);
            }
        }
    }

    // Return to List
    const backToList = () => {
        props.onClose();
        formReset();
    };

    return (
        <>
            <FormCreator
                config={projectStatusForm}
                ref={PlanningStatuseRef}
            />
            <div className="form-btn d-flex justify-content-end">
                <Buttons
                    buttonTypeClassName="dark-btn"
                    onClick={backToList}
                    buttonText="Cancel"
                />
                <Buttons
                    buttonTypeClassName="theme-btn ml-4"
                    imagePath={AppIcons.AddIcon}
                    buttonText={`${props.isEdit ? "Update" : "Add"}`}
                    onClick={handleSubmit}
                    isLoading={isPlanningStatusAdding || isPlanningStatusUpdating}
                />
            </div>
        </>
    );
}
AddEditPlanningStatus.propTypes = {
    planningStatusId: PropTypes.number,
    onClose: PropTypes.func,
};

export default AddEditPlanningStatus;